<template>
  <div>
    <el-dialog
      top="2vh"
      title="Colunas"
      :visible.sync="dialog.columns"
      width="30%">
      <ul class="list-group">
        <li class="list-group-item" v-for="column of current" :key="column">{{ column }}</li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialog.columns = false">OK</el-button>
      </span>
    </el-dialog>  

    <el-form
      ref="form"
      label-width="160px"
    >
        <el-form-item :label="$t('cliente')" prop="customer" v-if="userType !== '2' && userType !== '5'">
          <el-row :gutter="5">
            <el-col :xs="24" :sm="24" :md="16" :lg="10" :xl="10">
              <CustomerList
                v-model="customerList"
                :current="customer"
              />
            </el-col>
          </el-row>
        </el-form-item>
        <!--el-form-item :label="$t('meus-layouts')" prop="layout">
          <el-row :gutter="5">
            <el-col :xs="24" :sm="24" :md="16" :lg="10" :xl="10">
              <el-select
                v-model="layout"
                placeholder="Selecione uma opção"
                clearable
              >
                <el-option
                  v-for="layout in list"
                  :key="layout.id"
                  :label="layout.name"
                  :value="layout.id"
                >
                  <span style="float: left">{{ layout.name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">({{ layout.fields.split(',').length }} colunas)</span>
                </el-option>
              </el-select>
            </el-col>
            <el-col :xs="24" :sm="24" :md="8" :lg="10" :xl="10" v-if="layout">
              <el-button type="info" @click="open">Ver colunas</el-button>
              <el-button type="success" @click="apply">Aplicar</el-button>
              <el-button @click="remove">Remover esse layout</el-button>
            </el-col>
          </el-row>
        </!--el-form-item-->
    </el-form>
    <table class="table">
      <thead>
        <th class="w-33">Colunas</th>
        <th class="w-33">Valor Planilha</th>
        <th class="w-33">Campo</th>
      </thead>
      <tbody>
        <tr v-for="(item, index) of data" :key="index">
          <td>
            <el-tag type="primary">{{ item.column }}</el-tag>&nbsp;
            <el-checkbox v-model="item.ignore">Ignorar essa coluna</el-checkbox>
            </td>
          <td><el-tag type="info">{{ item.value }}</el-tag></td>
          <td>
            <el-select v-model="item.field" :disabled="item.ignore" filterable placeholder="Select">
              <el-option
                v-for="row in tableData"
                :key="row.key"
                :label="row.label"
                :value="row.key">
                <span style="float: left">{{ row.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 11px">{{ row.description }}</span>
              </el-option>
            </el-select>
          </td>
        </tr>
      </tbody>
    </table>
    <el-row :gutter="5" style="margin-top: 50px">
      <el-col
        :xs="12"
        :sm="12"
        :md="12"
        :lg="12"
        :xl="6"
        :offset="11"
        style="display: flex; justify-content: center"
      >
        <el-button @click="back()">Voltar</el-button>
        <el-button
          type="primary"
          ref="finish"
          @click="validate()"
          >Validar</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>
<script>
import CustomerList from "@/xpost/views/register/customer/CustomerList";
export default {
  name: "MappingColumn",
  props: ['fileData', 'columnData', 'customer', 'userType'],
  components: {
    CustomerList,
  },
  mounted() {
    const vm = this;
    vm.customerList = vm.customer;
    vm.tableData = vm.tableData.sort((a, b) => a.label.localeCompare(b.label));
    if (vm.columnData.length === 0) {
      if (vm.fileData.length === 0) return false;
      const fields = Object.keys(vm.fileData[0])
      for (let i=0; i < fields.length; i++) {
        const f = vm.tableData.find(x => x.key === fields[i]);
        vm.data.push({
          index: i,
          column: `Coluna ${vm.generate(i).toUpperCase()}`,
          value: vm.fileData[0][fields[i]],
          field: f ? f.key : '',
          ignore: false
        });
      }
    } else {
      vm.data = vm.columnData;
    }
  },
  methods: {
    next() {
      const vm = this;
      vm.$emit("next");
    },
    back() {
      const vm = this;
      vm.$emit("back");
    },
    generate(a) {
      var b = [a], sp, out, i, div;
      sp = 0;
      while(sp < b.length) {
        if (b[sp] > 25) {
          div = Math.floor(b[sp] / 26);
          b[sp + 1] = div - 1;
          b[sp] %= 26;
        }
        sp += 1;
      }

      out = "";
      for (i = 0; i < b.length; i += 1) {
        out = String.fromCharCode('a'.charCodeAt(0) + b[i]) + out;
      }

      return out;
    },
    validate() {
      const vm = this;
      const f = vm.data.filter(x => x.field === '');
      if (f.length > 0) {
        const x = f.filter(x => x.ignore === false);
        if (x.length > 0) {
          const t = x.reduce(function (a, b) {
            return (a.column || a) + ", " + b.column
          });
          return this.$message({
            type: "error",
            message: `Você precisa definir um campo ou ignorar as colunas (${t})!`,
            duration: 6000
          });
        }
      }
      const duplicate = vm.data.filter(y => {
        return vm.data.find(x => x.field === y.field && x.index !== y.index);
      });
      if (duplicate.length > 0) {
        const x = duplicate.filter(x => x.ignore === false);
        if (x.length > 1) {
          const t = x.reduce(function (a, b) {
            return (a.column || a) + ", " + b.column
          });
          return this.$message({
            type: "error",
            message: `Existem as colunas (${t}) que possuem o mesmo campo mapeado. Deve possuir apenas um campo por coluna!`,
            duration: 6000
          });
        }
      }
      const mandatory = vm.mandatory.filter(y => {
        return !vm.data.find(x => x.field === y);
      });
      if (mandatory.length > 0) {
        return this.$message({
          type: "error",
          message: `Os campos (${mandatory.join(', ')}) são obrigatórios, por favor selecionar a coluna correspondente para esse campo!`,
          duration: 6000
        });
      }
      if (vm.userType !== '2' && vm.userType !== '5' && !vm.customerList) {
        return this.$message({
          type: "error",
          message: `É obrigatório selecionar um cliente!`,
          duration: 6000
        });
      }
      const newFileData = [];
      for (let i=0; i < vm.fileData.length; i++) { 
        let record = vm.fileData[i];
        const keys = Object.keys(record);
        const newRecord = {};
        for (let x=0; x < vm.data.length; x++) { 
          const row = vm.data[x];
          if (row.ignore) continue;
          newRecord[row.field] = record[keys[x]];
        }
        newFileData.push(newRecord);
      }
      vm.$emit("validate", vm.data, vm.customerList, newFileData);
      vm.$emit("next");
      
    },
  },
  data() {
    return {
      data: [],
      list: [],
      layout: '',
      customerList: '',
      current: null,
      fields: [],
      dialog: {
        columns: false,
      },
      mandatory: ["NOME", "CEP", "NUMERO"],
      tableData: [
        { label: "NOME", key: "NOME", description: "NOME DO DESTINATÁRIO" },
        { label: "ENDERECO", key: "ENDERECO", description: "ENDEREÇO DO DESTINATÁRIO" },
        { label: "NUMERO", key: "NUMERO", description: "NÚMERO DO DESTINATÁRIO" },
        { label: "COMPLEMENTO", key: "COMPLEMENTO", description: "COMPLEMENTO DO ENDEREÇO DO DESTINATÁRIO" },
        { label: "BAIRRO", key: "BAIRRO", description: "BAIRRO DO DESTINATÁRIO" },
        { label: "CIDADE", key: "CIDADE", description: "CIDADE DO DESTINATÁRIO" },
        { label: "UF", key: "UF", description: "UF DO DESTINATÁRIO" },
        { label: "CEP", key: "CEP", description: "CEP DO DESTINATÁRIO" },
        { label: "TELEFONE", key: "TELEFONE", description: "TELEFONE DO DESTINATÁRIO" },
        { label: "CELULAR", key: "CELULAR", description: "CELULAR DO DESTINATÁRIO" },
        { label: "E-MAIL", key: "EMAIL", description: "E-MAIL DO DESTINATÁRIO" },
      ],
    }
  }
};
</script>
<style>
  .w-33 {
    width: 33%;
  }
  .table th, .table td {
    padding: 2px !important;
  }
  .list-group-item {
    padding: 2px 2px !important;
  }
</style>